import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './store';
import Layout from './components/Layout';
import CommandPalette from './components/CommandPalette';
import ToastContainer from './components/Toast';
import KeyboardShortcuts from './components/KeyboardShortcuts';
import Login from './pages/Login';
import Home from './pages/Home';
import NoteView from './pages/NoteView';
import GraphView from './pages/GraphView';
import Settings from './pages/Settings';
import TrashView from './pages/TrashView';
import TemplatesView from './pages/TemplatesView';
import RecentView from './pages/RecentView';

function ProtectedRoute({ children }) {
  const { isAuthenticated, isLoading } = useAuthStore();
  if (isLoading) return <div className="flex items-center justify-center h-screen"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" /></div>;
  return isAuthenticated ? children : <Navigate to="/login" />;
}

export default function App() {
  const { checkAuth } = useAuthStore();
  const [showShortcuts, setShowShortcuts] = useState(false);

  useEffect(() => { checkAuth(); }, []);
  useEffect(() => {
    const handler = (e) => {
      if (e.key === '?' && !e.target.closest('input, textarea')) { e.preventDefault(); setShowShortcuts(s => !s); }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<Home />} />
          <Route path="note/:id" element={<NoteView />} />
          <Route path="graph" element={<GraphView />} />
          <Route path="settings" element={<Settings />} />
          <Route path="trash" element={<TrashView />} />
          <Route path="templates" element={<TemplatesView />} />
          <Route path="recent" element={<RecentView />} />
        </Route>
      </Routes>
      <CommandPalette />
      <ToastContainer />
      <KeyboardShortcuts open={showShortcuts} onClose={() => setShowShortcuts(s => !s)} />
    </BrowserRouter>
  );
}
